module.exports = __webpack_public_path__ + "static/GoogleBadge-3cae0ac0de82a69b8fae7dcbb2c9c674.svg";